// extracted by mini-css-extract-plugin
module.exports = {"page":"C_page__MLns_"};